mutation ApprovalTestResultUpdate($input: ApprovalTestResultUpdateInput!) {
  approvalTestResultUpdate(input: $input) {
    approvalTestResult{
      id
    }
  }
}
